import SegmentedControl from 'components/inputs/segmented-control';
import PtacPreferencesField from 'components/structure-page/ptac-preferences-field';
import usePtacPreferences from 'hooks/use-ptac-preferences';
import {
  PTAC_AMPERAGE_ANSWER_OPTIONS,
  PTAC_VOLTAGE_ANSWER_OPTIONS
} from 'utils/ptac-preferences';

type PtacPreferencesCardProps = {
  systemUniqueId: string;
};

export default function PtacPreferencesCard({
  systemUniqueId
}: PtacPreferencesCardProps) {
  const { record, loaded, update } = usePtacPreferences(systemUniqueId);

  if (!loaded) {
    return (
      <div className='mb-4 rounded-lg border border-gray-200 bg-gray-50 p-3 text-sm text-gray-500'>
        Loading PTAC details…
      </div>
    );
  }

  const current = record ?? {};

  return (
    <section
      aria-label='PTAC details'
      className='flex flex-col gap-5 rounded-lg border border-gray-200 bg-white p-5'
    >
      <div>
        <h3 className='text-lg font-semibold text-gray-900'>
          Hotel Style PTAC details
        </h3>
        <p className='text-sm text-gray-500'>
          Verify the wall outlet before choosing units: a PTAC has to match the
          voltage and amperage already at the wall.
        </p>
      </div>
      <div className='flex flex-wrap gap-6'>
        <PtacPreferencesField
          label='Voltage at the outlet'
          hint='Check the outlet or the rating plate of the current unit.'
        >
          <SegmentedControl
            label='Voltage at the outlet'
            options={PTAC_VOLTAGE_ANSWER_OPTIONS}
            value={current.voltage ?? null}
            onChange={(value) => update({ ...current, voltage: value })}
          />
        </PtacPreferencesField>
        <PtacPreferencesField
          label='Amperage of the circuit'
          hint='The breaker size or the plug configuration tells you this.'
        >
          <SegmentedControl
            label='Amperage of the circuit'
            options={PTAC_AMPERAGE_ANSWER_OPTIONS}
            value={current.amperage ?? null}
            onChange={(value) => update({ ...current, amperage: value })}
          />
        </PtacPreferencesField>
      </div>
    </section>
  );
}
